import { createContext, useContext } from 'react';

export interface AccordionContextType {
  focusFirstButton: () => void;
  focusLastButton: () => void;
  focusNextButton: (currentButton: HTMLElement) => void;
  focusPreviousButton: (currentButton: HTMLElement) => void;
}

export const AccordionContext = createContext<AccordionContextType | null>(null);

export function useAccordionContext(componentName: string) {
  const context = useContext(AccordionContext);

  if (!context) {
    throw new Error(`<${componentName}> may be used only in the context of an <Accordion> component.`);
  }

  return context;
}
